import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Link } from 'react-router-dom';
//import logoSmall from '/BPL_sm.png';
import './Header.css';

export class Header extends Component {

    render() {
        return (
            <div className="sticky-top font-body shadow">
                <Router>
                    <nav className="navbar navbar-expand-lg navbar-light bg-white-transparent">
                        <a className="navbar-brand p-0" href="#home">
                            <img className="ml-3" src='Images/BPL_sm.png' style={{width: 40, height:30}}></img>
                        </a>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav mx-auto">
                                <li className="nav-item mx-3">
                                    <a className="nav-link" href="#home">Home <span className="sr-only">(current)</span></a>
                                </li>
                                <li className="nav-item mx-3">
                                    <a className="nav-link" href="#about">About</a>
                                </li>
                                <li className="nav-item mx-3">
                                    <a className="nav-link" href="#meet">Meet Us</a>
                                </li>
                                <li className="nav-item mx-3">
                                    <a className="nav-link" href="#partner">Our Partners</a>
                                </li>
                                <li className="nav-item mx-3">
                                    <a className="nav-link" href="#contact" tabindex="-1" aria-disabled="true">Contact</a>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </Router>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
